// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--1zzxF","body":"body--fkyLm"};